class Service {
    serviceId: number;
    serviceName: string;

    constructor() {
        this.serviceId = 0;
        this.serviceName = "";
    }
}

export default Service;